import Cookies from "js-cookie";
import { merchantList } from "@/api/business";

export const AMOUNT_REG = /^-?\d+(\.\d{1,2})?$/;
export const SUMMARY_REMARK = "当前汇总";

export function yuanToCents(yuan) {
  const text = String(yuan).trim();
  const negative = text.startsWith("-");
  const normalized = negative ? text.slice(1) : text;
  const parts = normalized.split(".");
  const intPart = parts[0] || "0";
  const decPart = (parts[1] || "").padEnd(2, "0").slice(0, 2);
  const cents = parseInt(intPart, 10) * 100 + parseInt(decPart, 10);
  return negative ? -cents : cents;
}

export function isActiveMerchant(item) {
  if (item.status === undefined || item.status === null || item.status === "") {
    return true;
  }
  return Number(item.status) === 0;
}

export async function fetchActiveMerchants() {
  const { data } = await merchantList({
    pageNum: 0,
    pageSize: 1000,
  });
  const list = (data && data.list) || [];
  return list
    .filter((item) => isActiveMerchant(item))
    .map((item) => ({
      ...item,
      merchantName: item.merchantName || `商户${item.merchantId}`,
    }));
}

export function checkPlatformUser() {
  return +Cookies.get("type") === 1;
}

export function checkPlatformAdminOrFinance() {
  const role = Cookies.get("storeId");
  return +Cookies.get("type") === 1 && (role === "1" || role === "2");
}
